import { DEFAULT_SNACKBAR } from 'constants/product';
import { SnackbarType } from 'types/product';


export const promiseWrapper = (promise: any) =>
  promise
    .then((data: any) => [data, undefined])
    .catch((error: any) => Promise.resolve([undefined, error]));

export const getSnackbarState = (id: string, status: boolean, msg: string, isError: boolean, isCart?: boolean = false) => {
  const snackbar: SnackbarType = { ...DEFAULT_SNACKBAR };
  snackbar.id = id;
  snackbar.status = status;
  snackbar.isError = isError;
  snackbar.msg = msg;
  snackbar.isCart = isCart;
  return snackbar;
};
